import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api/useGetQuery";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";

import type { ProfessionalReferenceResponse } from "../types";
import { professionalReferenceResponseSchema } from "../utils/validation";

const PROFESSIONAL_REFERENCES_BASE_URL = `${environmentConfig.REACT_APP_WORKER_SERVICE_URL}/references`;

export function useGetProfessionalReference(
  referenceId: string,
  options?: UseGetQueryOptions<ProfessionalReferenceResponse>
) {
  return useGetQuery({
    url: `${PROFESSIONAL_REFERENCES_BASE_URL}/${referenceId}`,
    responseSchema: professionalReferenceResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_PROFESSIONAL_REFERENCE_FAILURE,
    },
    enabled: Boolean(referenceId),
    ...options,
  });
}
